// Eski SPA'nın hash-based URL'lerini (`/destek/#/...`) yeni Nuxt rotalarına
// eşleyen tablo. Hash sunucuya gitmediği için server/middleware/legacy-redirects.ts
// bu URL'leri yakalayamaz; eşleşme client tarafında plugins/legacy-hash-redirect.client.ts
// içinde yapılır.
//
// Anahtar formatı (legacy-redirects.ts ile aynı convention):
//   - leading slash var, trailing slash yok
//   - query string yok (lookup öncesi soyulur)
//   - hedef tam path, baseURL (/destek/) dahil
export const LEGACY_HASH_REDIRECTS: Record<string, string> = {
  // accountAccessAndSecurity
  '/accountAccessAndSecurity': '/destek/guvenlik',
  '/accountAccessAndSecurity/accountAccess': '/destek/sorun-giderme/giris-yapamiyorum',
  '/accountAccessAndSecurity/accountAccess/cancel-account-lock':
    '/destek/sorun-giderme/hesabim-kilitlendi',
  '/accountAccessAndSecurity/accountAccess/cancel-account-lock/freeze-account':
    '/destek/hesap-yonetimi/hesap-dondurma',
  '/accountAccessAndSecurity/accountAccess/cancel-account-lock/reactive-account':
    '/destek/hesap-yonetimi/hesap-yeniden-etkinlestirme',
  '/accountAccessAndSecurity/accountAccess/cancel-account-lock/sms-lock':
    '/destek/sorun-giderme/hesabim-kilitlendi',
  '/accountAccessAndSecurity/accountAccess/forgot-pass': '/destek/guvenlik/parolami-unuttum',
  '/accountAccessAndSecurity/accountAccess/google2fa-error':
    '/destek/sorun-giderme/2fa-sorun-giderme',
  '/accountAccessAndSecurity/accountAccess/google2fa-error/google2fa-cancel':
    '/destek/guvenlik/2fa-devre-disi-birakma',
  '/accountAccessAndSecurity/accountAccess/no-sms-otp': '/destek/sorun-giderme/sms-kodu-gelmiyor',
  '/accountAccessAndSecurity/accountAccess/no-sms-otp/inbroad':
    '/destek/sorun-giderme/sms-kodu-gelmiyor',
  '/accountAccessAndSecurity/accountAccess/no-sms-otp/oversea':
    '/destek/sorun-giderme/sms-kodu-gelmiyor',
  '/accountAccessAndSecurity/paribu-access': '/destek/sorun-giderme',
  '/accountAccessAndSecurity/security': '/destek/guvenlik/phishing-korunma',
  '/accountAccessAndSecurity/security/report-lost-stolen': '/destek/guvenlik/phishing-korunma',
  '/accountAccessAndSecurity/security/report-suspicious': '/destek/guvenlik/phishing-korunma',
  '/accountAccessAndSecurity/veraset': '/destek/sorun-giderme/miras-vefat',

  // accountInfo
  '/accountInfo': '/destek/hesap-yonetimi/profil-ve-kisisel-bilgiler',
  '/accountInfo/email-update': '/destek/sorun-giderme/eposta-degisikligi',
  '/accountInfo/mobile-update': '/destek/sorun-giderme/telefon-degisikligi',
  '/accountInfo/name-update': '/destek/sorun-giderme/ad-soyad-degisikligi',
  '/accountInfo/name-update/due-court-decision': '/destek/sorun-giderme/ad-soyad-degisikligi',
  '/accountInfo/name-update/due-marital-status': '/destek/sorun-giderme/ad-soyad-degisikligi',
  '/accountInfo/name-update/incorrect-name': '/destek/sorun-giderme/ad-soyad-degisikligi',
  '/accountInfo/verification': '/destek/baslangic/kyc-kimlik-dogrulama',
  '/accountInfo/verification/blue-card': '/destek/baslangic/kyc-kimlik-dogrulama',
  '/accountInfo/verification/cant-verify': '/destek/sorun-giderme/kyc-basarisiz',
  '/accountInfo/verification/cant-verify/kyc-fail-account-information':
    '/destek/sorun-giderme/kyc-basarisiz',
  '/accountInfo/verification/cant-verify/kyc-fail-facial':
    '/destek/sorun-giderme/yuz-dogrulama-basarisiz',
  '/accountInfo/verification/cant-verify/kyc-fail-start': '/destek/sorun-giderme/kyc-basarisiz',
  '/accountInfo/verification/cant-verify/kyc-nfc': '/destek/sorun-giderme/nfc-okuma-hatasi',
  '/accountInfo/verification/cant-verify/kyc-unloading-adress':
    '/destek/sorun-giderme/edevlet-belgesi-sorunlari',
  '/accountInfo/verification/cant-verify/kyc-unread-identity':
    '/destek/sorun-giderme/kyc-basarisiz',
  '/accountInfo/verification/foreign_identity_card': '/destek/baslangic/kyc-kimlik-dogrulama',

  // bjkToken
  '/bjkToken': '/destek/kripto-islemleri',
  '/bjkToken/0': '/destek/alim-satim/kripto-varlik-alim-satim',
  '/bjkToken/1': '/destek/alim-satim',
  '/bjkToken/2': '/destek/kripto-islemleri',
  '/bjkToken/3': '/destek/kripto-islemleri',
  '/bjkToken/4': '/destek/kripto-islemleri',
  '/bjkToken/5': '/destek/kripto-islemleri/kripto-cekme',
  '/bjkToken/6': '/destek/kripto-islemleri',
  '/bjkToken/7': '/destek/kripto-islemleri',
  '/bjkToken/8': '/destek/alim-satim',
  '/bjkToken/9': '/destek/alim-satim',
  '/bjkToken/10': '/destek/alim-satim',
  '/bjkToken/11': '/destek/alim-satim/kripto-varlik-alim-satim',
  '/bjkToken/12': '/destek/kripto-islemleri/kripto-yatirma',
  '/bjkToken/other': '/destek/kripto-islemleri',

  // career, corporate, marketMakingProgram, institutions, partnership, listing
  '/career': '/destek',
  '/corporate': '/destek',
  '/institutions': '/destek',
  '/listing': '/destek/yasal/kripto-varlik-listeleme-ve-listeden-cikarma-proseduru',
  '/marketMakingProgram': '/destek',
  '/partnership': '/destek',

  // cryptoTransactions
  '/cryptoTransactions': '/destek/kripto-islemleri',
  '/cryptoTransactions/arbitrage': '/destek/alim-satim',
  '/cryptoTransactions/deposit': '/destek/kripto-islemleri/kripto-yatirma',
  '/cryptoTransactions/deposit/not-recieved': '/destek/sorun-giderme/kripto-yatirma-gorulmuyor',
  '/cryptoTransactions/deposit/wrong': '/destek/kripto-islemleri/kripto-yatirma',
  '/cryptoTransactions/deposit/wrong/address': '/destek/sorun-giderme/yanlis-ag-transfer',
  '/cryptoTransactions/deposit/wrong/nonchain-deposit': '/destek/sorun-giderme/yanlis-ag-transfer',
  '/cryptoTransactions/deposit/wrong/nonlist-deposit': '/destek/kripto-islemleri/kripto-yatirma',
  '/cryptoTransactions/deposit/wrong/tag-memo-null': '/destek/sorun-giderme/memo-tag-unutuldu',
  '/cryptoTransactions/deposit/wrong/tag-memo-wrong': '/destek/sorun-giderme/memo-tag-unutuldu',
  '/cryptoTransactions/information': '/destek/kripto-islemleri',
  '/cryptoTransactions/information/how-to-deposit': '/destek/kripto-islemleri/kripto-yatirma',
  '/cryptoTransactions/information/how-to-witdraw': '/destek/kripto-islemleri/kripto-cekme',
  '/cryptoTransactions/information/withdraw-fees':
    '/destek/kripto-islemleri/kripto-cekme-limitleri-ucretleri-ve-sureleri',
  '/cryptoTransactions/information/withdraw-limits':
    '/destek/kripto-islemleri/kripto-cekme-limitleri-ucretleri-ve-sureleri',
  '/cryptoTransactions/withdraw': '/destek/kripto-islemleri/kripto-cekme',
  '/cryptoTransactions/withdraw/email-not-recieved':
    '/destek/sorun-giderme/kripto-cekme-onay-epostasi',
  '/cryptoTransactions/withdraw/not-recieved': '/destek/sorun-giderme/kripto-cekme-basarisiz',
  '/cryptoTransactions/withdraw/withdraw-restriction':
    '/destek/kripto-islemleri/72-ve-48-saat-bekleme-sureleri',
  '/cryptoTransactions/withdraw/wrong': '/destek/kripto-islemleri/kripto-cekme',

  // feedback
  '/feedback': '/destek',
  '/feedback/closeAccount': '/destek/hesap-yonetimi/hesap-kapatma',
  '/feedback/closeAccount/account-close-cancel-request': '/destek/hesap-yonetimi/hesap-kapatma',
  '/feedback/closeAccount/account-not-closed': '/destek/hesap-yonetimi/hesap-kapatma',
  '/feedback/closeAccount/account-reopen': '/destek/hesap-yonetimi/hesap-yeniden-etkinlestirme',
  '/feedback/closeAccount/close-account': '/destek/hesap-yonetimi/hesap-kapatma',
  '/feedback/complain': '/destek',
  '/feedback/feedback': '/destek',
  '/feedback/feedback/general': '/destek',
  '/feedback/feedback/other': '/destek',
  '/feedback/feedback/phone': '/destek',
  '/feedback/feedback/support': '/destek',
  '/feedback/feedback/system': '/destek',
  '/feedback/request': '/destek',

  // fiatTransactions
  '/fiatTransactions': '/destek/tl-islemleri',
  '/fiatTransactions/information': '/destek/tl-islemleri',
  '/fiatTransactions/information/after-hours-deposit':
    '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/fiatTransactions/information/after-hours-witdraw':
    '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/fiatTransactions/information/how-to-deposit': '/destek/tl-islemleri/tl-yatirma',
  '/fiatTransactions/information/how-to-witdraw': '/destek/tl-islemleri/tl-cekme',
  '/fiatTransactions/information/wrong-name-deposit': '/destek/sorun-giderme/tl-yatirma-iade',
  '/fiatTransactions/information/wrong-name-witdraw': '/destek/sorun-giderme/tl-cekme-basarisiz',
  '/fiatTransactions/tl-deposit': '/destek/tl-islemleri/tl-yatirma',
  '/fiatTransactions/tl-deposit/atm-deposit': '/destek/sorun-giderme/tl-atm-yatirma',
  '/fiatTransactions/tl-deposit/creditcard–deposit': '/destek/sorun-giderme/tl-kredi-karti-yatirma',
  '/fiatTransactions/tl-deposit/different-deposit': '/destek/sorun-giderme/tl-ortak-hesap-yatirma',
  '/fiatTransactions/tl-deposit/information': '/destek/tl-islemleri/tl-yatirma',
  '/fiatTransactions/tl-deposit/information/after-hours':
    '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/fiatTransactions/tl-deposit/information/how': '/destek/tl-islemleri/tl-yatirma',
  '/fiatTransactions/tl-deposit/information/wrongName': '/destek/sorun-giderme/tl-yatirma-iade',
  '/fiatTransactions/tl-deposit/not-recieved': '/destek/sorun-giderme/tl-yatirma-gorulmuyor',
  '/fiatTransactions/tl-withdraw': '/destek/tl-islemleri/tl-cekme',
  '/fiatTransactions/tl-withdraw/information': '/destek/tl-islemleri/tl-cekme',
  '/fiatTransactions/tl-withdraw/information/after-hours':
    '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/fiatTransactions/tl-withdraw/information/how': '/destek/tl-islemleri/tl-cekme',
  '/fiatTransactions/tl-withdraw/information/wrongName': '/destek/sorun-giderme/tl-cekme-basarisiz',
  '/fiatTransactions/tl-withdraw/limits':
    '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/fiatTransactions/tl-withdraw/not-recieved': '/destek/sorun-giderme/tl-cekme-ulasmadi',
  '/fiatTransactions/tl-withdraw/third-party': '/destek/sorun-giderme/tl-cekme-basarisiz',

  // finance
  '/finance': '/destek/hesap-yonetimi',
  '/finance/cant-use': '/destek/sorun-giderme',
  '/finance/invoice': '/destek',
  '/finance/issues': '/destek/sorun-giderme/bakiye-gorulmuyor',
  '/finance/user-log': '/destek/hesap-yonetimi/hesap-ozeti-islem-gecmisi-alma',

  // guide
  '/guide': '/destek',
  '/guide/1': '/destek/baslangic/paribu-nedir',
  '/guide/2': '/destek/baslangic/paribu-nedir',
  '/guide/3': '/destek/baslangic/hesap-olusturma',
  '/guide/3/3-1': '/destek/baslangic/hesap-olusturma',
  '/guide/3/3-2': '/destek/baslangic/kyc-kimlik-dogrulama',
  '/guide/3/3-3': '/destek/baslangic/kyc-kimlik-dogrulama',
  '/guide/4': '/destek/baslangic/hesap-olusturma',
  '/guide/5': '/destek/guvenlik',
  '/guide/5/5-1': '/destek/guvenlik/guvenlik-ipuclari',
  '/guide/5/5-2': '/destek/guvenlik/parola-degistirme',
  '/guide/5/5-3': '/destek/guvenlik/2fa-kurulumu',
  '/guide/5/5-4': '/destek/guvenlik/2fa-devre-disi-birakma',
  '/guide/5/5-5': '/destek/guvenlik',
  '/guide/5/5-6': '/destek/guvenlik',
  '/guide/5/5-7': '/destek/guvenlik/api-anahtarlari',
  '/guide/6': '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/guide/6/6-1': '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/guide/6/6-2': '/destek/tl-islemleri/tl-cekme',
  '/guide/6/6-3': '/destek/sorun-giderme/tl-yatirma-iade',
  '/guide/7': '/destek/kripto-islemleri',
  '/guide/7/7-1': '/destek/kripto-islemleri/kripto-yatirma',
  '/guide/7/7-2': '/destek/kripto-islemleri/kripto-cekme',
  '/guide/7/7-3': '/destek/sorun-giderme/yanlis-ag-transfer',
  '/guide/8': '/destek/alim-satim',
  '/guide/8/8-1': '/destek/alim-satim/kripto-varlik-alim-satim',
  '/guide/8/8-2': '/destek/alim-satim',
  '/guide/8/8-3': '/destek/tl-islemleri/blokeli-bakiye',
  '/guide/8/8-4': '/destek/alim-satim',
  '/guide/8/8-5': '/destek/sorun-giderme/emir-gerceklesmedi',
  '/guide/8/8-6': '/destek/alim-satim/komisyon-maker-taker',
  '/guide/8/8-7': '/destek/yatirim/fiyat-alarmlari',
  '/guide/8/8-8': '/destek/alim-satim/hizli-gorunumde-al-sat',
  '/guide/8/8-9': '/destek/alim-satim/limit-emri',
  '/guide/8/8-10': '/destek/alim-satim/piyasa-emri',
  '/guide/8/8-11': '/destek/alim-satim/kosullu-emir',
  '/guide/9': '/destek/kripto-islemleri/kripto-cekme-limitleri-ucretleri-ve-sureleri',
  '/guide/9/9-1': '/destek/alim-satim/komisyon-maker-taker',
  '/guide/9/9-2': '/destek/kripto-islemleri/kripto-cekme-limitleri-ucretleri-ve-sureleri',
  '/guide/9/9-3': '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/guide/9/9-5': '/destek/tl-islemleri/tl-yatirma-cekme-limitleri-ve-sureleri',
  '/guide/9/9-6': '/destek/kripto-islemleri/kripto-cekme-limitleri-ucretleri-ve-sureleri',
  '/guide/9/9-7': '/destek/alim-satim',

  // trade
  '/trade': '/destek/alim-satim',
  '/trade/0': '/destek/sorun-giderme/emir-gerceklesmedi',
  '/trade/1': '/destek/sorun-giderme/emir-gerceklesmedi',
  '/trade/2': '/destek/alim-satim/komisyon-maker-taker',
  '/trade/3': '/destek/alim-satim/limit-emri',
  '/trade/4': '/destek/alim-satim/piyasa-emri',
  '/trade/5': '/destek/alim-satim/hizli-gorunumde-al-sat',
  '/trade/6': '/destek/alim-satim/kosullu-emir',
  '/trade/7': '/destek/alim-satim',
  '/trade/8': '/destek/alim-satim',
  '/trade/9': '/destek/alim-satim/komisyon-maker-taker',
  '/trade/10': '/destek/alim-satim',
  '/trade/11': '/destek/yatirim/portfoy-goruntuleme',
  '/trade/12': '/destek/yatirim/fiyat-alarmlari',
  '/trade/13': '/destek/hesap-yonetimi/loyalty-seviyeleri',
}
